module.exports = __WEBPACK_EXTERNAL_MODULE_236__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 236
// module chunks = 0